import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TeamsService } from './teamsApi';
import { ITeamMembersListState } from '../../../../interfaces/teams/ITeamMembersListState';
import { PaginatedTeamMembers } from '../../../../interfaces/teams/paginatedStore.type';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';

const initialState: ITeamMembersListState = {
    membersAreLoading: false,
    memberIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchAllTeamMembers = createAsyncThunk<any, any>(
    'teams/tryToFetchAllTeamMembers',
    async (data: any) => {
        const result = await TeamsService.tryToFetchAllTeamMembers(data);
        return result?.data?.data;
    }
);

export const tryToFetchTeamMembers = createAsyncThunk<PaginatedTeamMembers, IPaginationPayload>(
    'teams/tryToFetchTeamMembers',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await TeamsService.tryToFetchTeamMembers(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchTeamMembersSidebar = createAsyncThunk<PaginatedTeamMembers, IPaginationPayload>(
    'teams/tryToFetchTeamMembersSidebar',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await TeamsService.tryToFetchTeamMembers(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);


export const tryToFetchSingleTeamMember = createAsyncThunk<any, string>(
    'teams/tryToFetchSingleTeamMember',
    async (id) => {
        const result = await TeamsService.tryToFetchSingleTeamMember(id);
        return result?.data;
    }
);

export const tryToDeleteTeamMembers = createAsyncThunk<any, any>(
    'teams/tryToDeleteTeamMembers',
    async (data) => {
        const result = await TeamsService.tryToDeleteTeamMembers(data);
        return result?.data;
    }
);

export const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchAllTeamMembers
            .addCase(tryToFetchAllTeamMembers.pending, (state) => {
                state.membersAreLoading = true;
            })
            .addCase(tryToFetchAllTeamMembers.rejected, (state) => {
                state.membersAreLoading = false;
            })
            .addCase(tryToFetchAllTeamMembers.fulfilled, (state, action) => {
                state.membersAreLoading = false;
                state.allTeamMembers = action.payload;
            })

            // tryToFetchTeamMembers
            .addCase(tryToFetchTeamMembers.pending, (state) => {
                state.membersAreLoading = true;
            })
            .addCase(tryToFetchTeamMembers.rejected, (state) => {
                state.membersAreLoading = false;
            })
            .addCase(tryToFetchTeamMembers.fulfilled, (state, action) => {
                state.membersAreLoading = false;
                state.teamMembers = action.payload;
            })

            // tryToFetchTeamMembersSidebar
            .addCase(tryToFetchTeamMembersSidebar.pending, (state) => {
                state.memberIsLoading = true;
            })
            .addCase(tryToFetchTeamMembersSidebar.rejected, (state) => {
                state.memberIsLoading = false;
            })
            .addCase(tryToFetchTeamMembersSidebar.fulfilled, (state, action) => {
                state.memberIsLoading = false;
                state.teamMembersSidebar = action.payload;
            })

            // tryToFetchSingleTeamMember
            .addCase(tryToFetchSingleTeamMember.pending, (state) => {
                state.memberIsLoading = true;
            })
            .addCase(tryToFetchSingleTeamMember.rejected, (state) => {
                state.memberIsLoading = false;
            })
            .addCase(tryToFetchSingleTeamMember.fulfilled, (state, action) => {
                state.memberIsLoading = false;
                state.teamMember = action.payload;
            })

            // tryToDeleteTeamMembers
            .addCase(tryToDeleteTeamMembers.pending, (state) => {
                state.memberIsLoading = true;
            })
            .addCase(tryToDeleteTeamMembers.rejected, (state) => {
                state.memberIsLoading = false;
            })
            .addCase(tryToDeleteTeamMembers.fulfilled, (state, action) => {
                state.memberIsLoading = false;
                if (state.teamMembers?.data.elements)
                    state.teamMembers.data.elements =
                        { ...state }.teamMembers?.data.elements.map((member) => {
                            if (member?.status === 'live') {
                                return {
                                    ...member,
                                    status: 'delete',
                                };
                            } else {
                                return member;
                            }
                        }) || [];
            })

    },
});

export default teamsSlice.reducer;